module.exports = __webpack_public_path__ + "img/credit_card.93cc08a7.svg";